import { Button, Link } from '@huntington/honeycomb';
import { ColorBaseWhite } from '@huntington/honeycomb-design';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import {
	API_ERROR_PAGE_DESCRIPTION_PREFIX,
	API_ERROR_PAGE_DESCRIPTION_PREFIX_MOBILE,
	API_ERROR_PAGE_DESCRIPTION_SUFFIX,
	API_ERROR_PAGE_DESCRIPTION_SUFFIX_MOBILE,
	API_ERROR_PAGE_TITLE,
	CIRCADIA_HELP_EMAIL,
	CONTACT_US_OK_BUTTON,
} from '../../constants/messages';
import { ROUTE_LOGIN } from '../../router/router';

export default function EnrollmentError() {
	const isTabletOrMobile = useMediaQuery((theme: any) => theme.breakpoints.down('md'));

	return (
		<Box>
			<Typography
				component="h1"
				variant="h1"
				fontWeight={700}
				fontSize={{ xs: '1.5rem', md: '2.25rem' }}
				fontFamily='"Huntington Serif", serif'
			>
				{API_ERROR_PAGE_TITLE}
			</Typography>
			<Typography pt={{ xs: '1.5rem', md: '2rem' }} pb="2.5rem">
				{isTabletOrMobile
					? API_ERROR_PAGE_DESCRIPTION_PREFIX_MOBILE
					: API_ERROR_PAGE_DESCRIPTION_PREFIX}
				<Link href={`mailto:${CIRCADIA_HELP_EMAIL}`}>{CIRCADIA_HELP_EMAIL}</Link>
				{isTabletOrMobile
					? API_ERROR_PAGE_DESCRIPTION_SUFFIX_MOBILE
					: API_ERROR_PAGE_DESCRIPTION_SUFFIX}
			</Typography>
			<Stack direction={'row'} justifyContent={'flex-end'}>
				<Button href={ROUTE_LOGIN} sx={{ '&:hover': { color: ColorBaseWhite } }}>
					{CONTACT_US_OK_BUTTON}
				</Button>
			</Stack>
		</Box>
	);
}
